require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2021-05-11-congratulations-to-julien-for-obtaining-the-frsq-scholarship-award-in-this-year-competition-may-2021.json") })
        }
      }, "path---news-2021-05-11-congratulations-to-julien-for-obtaining-the-frsq-scholarship-award-in-this-year-competition-may-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2021-05-11-congratulations-to-julien-for-obtaining-the-frsq-scholarship-award-in-this-year-competition-may-2021!./.cache/json/news-2021-05-11-congratulations-to-julien-for-obtaining-the-frsq-scholarship-award-in-this-year-competition-may-2021.json
// module id = 471
// module chunks = 231608221292675